module.exports = __webpack_public_path__ + "images/python-talk-is-cheap.webp";